import{useContext}from"react";import{RouterLinkContext}from"../../contexts/router-link.context.js";function useRouterContext(){return{RouterLink:useContext(RouterLinkContext)}}export{useRouterContext};
